/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input, Output } from "@angular/core";
import { AbstractModalComponentWithCheckBox } from "../abstract-modal.component.with-checkbox";

@Component({
   standalone: false,
   selector: "cancel-confirm-dialog-with-checkbox",
   templateUrl: "./cancel-confirm-dialog-with-checkbox.component.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 451.89px;
         }
      `
   ]
})
export class CancelConfirmDialogWithCheckBoxComponent extends AbstractModalComponentWithCheckBox {
   @Input() public title;
   @Input() public message;
   @Input() public buttonLabelConfirm?;
   @Input() public buttonLabelCancel?;
   @Input() public checkboxTitle?;
   @Input() public showCancelButton?;
}
